import useLocalStore from '../../../hooks/useLocalStore';
import FJHeaderConfig from '../../../config/FJHeaderConfig';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import { LOCAL } from '../../../constants/FJEvnConstant';
import FJMobileHeader from './FJMobileHeader';
import { useSelector, useDispatch } from 'react-redux';
import { setSliceIsShowMobileHistory } from '../../../redux/slices/FJSliceCommon';
import FJActionCommon from '../../../redux/action/FJActionCommon';
const environment = import.meta.env.MODE;
const isLocal = environment === LOCAL;

const FJMobileHeaderContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const creditNumber = useSelector(state => state.common.creditNumber);
    const isLogin = useSelector(state => state.common.isLogin);

    const curLag = FJLocalStore.currentTag();
    const _getHref = useCallback(
        href => {
            return isLocal ? href.replace('/apply', '') : `/${curLag}${href}`;
        },
        [curLag],
    );
    const aiToolList = useMemo(() => {
        return FJHeaderConfig.aiMenuList
            .filter(item => item.hasMobile)
            .map(item => ({
                title: item.title,
                href: _getHref(item.href),
                icon: item.icon,
            }));
    }, [_getHref]);
    const onHistoryClick = useCallback(() => {
        dispatch(setSliceIsShowMobileHistory(true));
    }, [dispatch]);
    const _getCredits = useCallback(() => {
        dispatch(FJActionCommon.getCreditsAction());
    }, [dispatch]);
    return (
        <FJMobileHeader
            aiToolList={aiToolList}
            onHistoryClick={onHistoryClick}
            creditNumber={creditNumber}
            isLogin={isLogin}
            getCredits={_getCredits}
        />
    );
};

export default FJMobileHeaderContainer;
